<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-11 14:41:49
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-ckj.vue
 * @Description: 茶科技
-->
<template>
  <div class="ckj">
    <div class="content">
      <chart-pie class="qsrh" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions('company-profile', ['getCKJ'])
  },
  created () {
    this.getCKJ()
  }
}
</script>

<style lang="scss">
.ckj {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    .qsrh {
      height: calc(100% - 26px);
      width: 305px;
      margin: 13px auto;
    }
  }
}
</style>
